export const CTA_TYPES = {
  TELEPHONE_NUMBER: 'Telephone number',
  LINK: 'Link',
}
